import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import nth0 from "@/modules/nth0";
import { IGameTableType } from "@/types/GlobalTypes";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import { twelveDReds } from "@/modules/commonMobile";
import zeroFill from "@/modules/zeroFill";
import { isIPhone } from "@/modules/iOSDetection";

export default class P9Portrait extends React.PureComponent<IGameTableType> {
	render() {
		const { langdata } = this.props;

		const win = this.props.win ? Number(this.props.win) : null;
		const winStr = this.props.win ? zeroFill(win, 2) : null;

		const isJackpot = win && win === 20;
		const allowWin = win && !isJackpot;

		const pcodeProp = { pcode: this.props.pcode };
		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return (
			<div className="sl-table">
				<div className="row">
					<div className={"sl-bet col-xs-6 sl-green-old" + (allowWin && (win <= 6 && win > 0) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Small",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						<div className="bet-type">1:0.95</div>
						<div className="bet-label">{this.props.langdata["txt_small"]}</div>

						<Chips {...commonChipProps} betKey="Small+n50" />
					</div>
					<div className={"sl-bet col-xs-6 sl-green-old" + (allowWin && (win >= 7) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Big",
							group: "n50",
							...pcodeProp
						}}
						//bet="Big" pcode={this.props.pcode} group="n50"
						onClick={this.props.insertBet}>
						<div className="bet-type">1:0.95</div>
						<div className="bet-label">{this.props.langdata["txt_big"]}</div>

						<Chips {...commonChipProps} betKey="Big+n50" />
					</div>
				</div>

				<div className="row">
					<div className={"sl-bet col-xs-6 sl-green-old" + (allowWin && (win % 2) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Odd",
							group: "n50",
							...pcodeProp
						}}
						//bet="Odd" pcode={this.props.pcode} group="n50"
						onClick={this.props.insertBet}>
						<div className="bet-type">1:0.95</div>
						<div className="bet-label">{this.props.langdata["txt_odd"]}</div>

						<Chips {...commonChipProps} betKey="Odd+n50" />
					</div>
					<div className={"sl-bet col-xs-6 sl-green-old" + (allowWin && !(win % 2) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Even",
							group: "n50",
							...pcodeProp
						}}
						//bet="Even" pcode={this.props.pcode} group="n50"
						onClick={this.props.insertBet}>
						<div className="bet-type">1:0.95</div>
						<div className="bet-label">{this.props.langdata["txt_even"]}</div>

						<Chips {...commonChipProps} betKey="Even+n50" />
					</div>
				</div>

				<div className="row">
					<div className={"sl-bet col-xs-6 sl-red-lighten" + (allowWin && (twelveDReds.indexOf(Number(win)) >= 0) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Red",
							group: "n50",
							...pcodeProp
						}}
						// bet="Red" pcode={this.props.pcode} group="n50"
						onClick={this.props.insertBet}>

						<div className="bet-type">1:0.95</div>
						<div className="bet-label">{this.props.langdata["txt_red"]}</div>

						<Chips {...commonChipProps} betKey="Red+n50" />
					</div>
					<div className={"sl-bet col-xs-6 sl-black-lighten" + (allowWin && (twelveDReds.indexOf(Number(win)) < 0) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Black",
							group: "n50",
							...pcodeProp
						}}
						//bet="Black" pcode={this.props.pcode} group="n50"
						onClick={this.props.insertBet}>
						<div className="bet-type">1:0.95</div>
						<div className="bet-label">{this.props.langdata["txt_black"]}</div>

						<Chips {...commonChipProps} betKey="Black+n50" />
					</div>
				</div>

				<div className="row">
					<div className={"sl-bet col-xs-12 sl-green-lighten" + (isJackpot ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Jackpot",
							group: "jackpot",
							...pcodeProp
						}}
						// bet="Jackpot" pcode={this.props.pcode} group="jackpot"
						onClick={this.props.insertBet}>
						<div className="bet-type">1:44</div>
						<div className="bet-label">{this.props.langdata["txt_jackpot"]}</div>

						<Chips {...commonChipProps} betKey="Jackpot+jackpot" />
					</div>

				</div>

				<div className="row">
					{
						[["01", "04", "07", 10],
						["02", "05", "08", 11],
						["03", "06", "09", 12]].map((group, groupIdx) => {
							const betKey = group.join(",");
							return <div className={"sl-bet col-xs-3 sl-green-old" + (allowWin && group.indexOf(win) >= 0 ? " sl-yellow-alternating" : "")}
								{...{
									bet: betKey,
									group: "n4",
									...pcodeProp
								}}
								key={"p9_n4" + betKey}
								// bet={betKey} pcode={this.props.pcode} group="n4"
								onClick={this.props.insertBet}>

								<div className="bet-type">1:1.75</div>
								<div className="bet-label">{nth0(groupIdx)}</div>

								<Chips {...commonChipProps} betKey={betKey + "+n4"} />
							</div>;
						})
					}

				</div>

				<div className="row">
					{
						[["01", "02", "03"], ["04", "05", "06"], ["07", "08", "09"], ["10", "11", "12"]].map((group, groupIdx) => {
							const nth = nth0(groupIdx);
							const betKey = group.join(",");

							return [...group.map((num, idxGroup) =>
								<div className={"sl-bet col-xs-3 "
									+ (twelveDReds.indexOf(Number(num)) >= 0 ? "sl-red-lighten" : "sl-black-lighten")
									+ (allowWin && (Number(win) === Number(num)) ? " sl-yellow-alternating" : "")}
									{...{
										bet: num,
										group: "n",
										...pcodeProp
									}}
									key={"p9_n" + betKey + "_" + idxGroup}
									// bet={num} pcode={this.props.pcode} group="n"
									onClick={this.props.insertBet}>

									<div className="bet-type">1:10</div>
									<div className="bet-label">{num}</div>

									<Chips {...commonChipProps} betKey={num + "+n"} />
								</div>),

							<div className={"sl-bet col-xs-3 sl-green-old" + (allowWin && group.indexOf(winStr) >= 0 ? " sl-yellow-alternating" : "")}
								{...{
									bet: betKey,
									group: "n3",
									...pcodeProp
								}}
								key={"p9_n3" + betKey}
								//bet={betKey} pcode={this.props.pcode} group="n3"
								onClick={this.props.insertBet}>
								{nth}
								<div className="bet-type">1:2.6</div>
								<Chips {...commonChipProps} betKey={betKey + "+n3"} />
							</div>
							];
						})
					}
				</div>

				{/*Mobile portrait multibet starts here*/}
				{
					[["01,04", "02,05", "03,06"],
					["04,07", "05,08", "06,09"],
					["07,10", "08,11", "09,12"]].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = 0;
							const leftSpace = 25;

							return <div className={"sl-bet hidden col-xs-3"}
								key={"p9_row_n2" + groupComma}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
									top: "calc(64% + " + (rowIdx * 6) + "vh)",
									background: "transparent",
									border: "none",
									height: "3vh"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"
									{...{
										bet: groupComma,
										group: "n2",
										...pcodeProp
									}}
									// bet={groupComma} pcode={this.props.pcode} group="n2"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[["01,02", "02,03"],
					["04,05", "05,06"],
					["07,08", "08,09"],
					["10,11", "11,12"]].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = 21.5;
							const leftSpace = 25;

							return <div className={"sl-bet hidden col-xs-1"}
								key={"p9_row_n2" + groupComma}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
									top: "calc(58% + " + (rowIdx * 6) + "vh)",
									// background: "rgba(255,255,0,0.5)",
									background: "transparent",
									border: "none",
									height: "3vh"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"
									{...{
										bet: groupComma,
										group: "n2",
										...pcodeProp
									}}
									//bet={groupComma} pcode={this.props.pcode} group="n2"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[["01,02,04,05", "02,03,05,06"],
					["04,05,07,08", "05,06,08,09"],
					["07,08,10,11", "08,09,11,12"]].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = 21.5;
							const leftSpace = 25;

							return <div className={"sl-bet hidden col-xs-1"}
								key={"p9_row_n4" + groupComma}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
									top: "calc(64% + " + (rowIdx * 6) + "vh)",
									background: "transparent",
									border: "none",
									height: "3vh"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
								<div className="sl-hover-hidden"
									{...{
										bet: groupComma,
										group: "n4",
										...pcodeProp
									}}
									// bet={groupComma} pcode={this.props.pcode} group="n4"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}
				{/* END OF MOBILE PORTRAIT */}
			</div>
		);
	}
}